module.exports = __webpack_public_path__ + "img/ring_y_o_0_0@2x.df458979.png";